import React, { Fragment } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
  Container,
  SearchContainer,
  LoaderWrapper,
  LoadingStyled,
  FormWrapper,
  InputSearch,
  DividerStyled,
} from './styles';

const InfinityContent = ({
  inputSearchLabel,
  searchChange,
  data,
  dataFiltered,
  loading,
  fetchAllData,
  hasMore,
  queryParamas,
  children,
}) => (
  <Fragment>
    <SearchContainer>
      <FormWrapper component="form">
        <InputSearch
          label={inputSearchLabel}
          variant="filled"
          onChange={searchChange}
          value={queryParamas}
        />
      </FormWrapper>
      <DividerStyled />
    </SearchContainer>
    <Container customers id="scrollableDiv">
      <InfiniteScroll
        dataLength={
          dataFiltered.length !== 0 ? dataFiltered.length : data.length
        }
        next={fetchAllData}
        hasMore={hasMore}
        loader={
          !queryParamas && (
            <LoaderWrapper>
              <LoadingStyled />
            </LoaderWrapper>
          )
        }
        style={{paddingLeft: '4px'}}
        scrollableTarget="scrollableDiv"
      >
        {queryParamas && loading ? (
          <LoaderWrapper>
            <LoadingStyled />
          </LoaderWrapper>
        ) : (
          children
        )}
      </InfiniteScroll>
    </Container>
  </Fragment>
);

export default InfinityContent;
